import * as t from '@/types'
import Routes from '@/routes'

const variables: t.Variable[] = [
  {
    name: 'Mobile Phones',
    type: t.VariableType.single,
    description: 'Don’t forget to include all the mobile phone bills (Spouse / Children!)',
    variable: 'Mobile_Phone_Amt',
    frequency: 'Mobile_Phone_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Personal Care',
    type: t.VariableType.single,
    description: 'Include those salon and barber visits and anything else that keeps you looking great!',
    variable: 'Personal_Care_Amt',
    frequency: 'Personal_Care_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Classes and Club / Gym Membership',
    type: t.VariableType.single,
    description: 'Add in the cost of any recurring activities - Gyms, Golf, Swimming, Drama, Music etc',
    variable: 'Club_membership_Amt',
    frequency: 'Club_membership_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Clothing & Shoes',
    type: t.VariableType.single,
    description: 'From clothes, coats and shoes to rain gear, gloves and scarves',
    variable: 'Clothing_Amt',
    frequency: 'Clothing_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Gifts (Birthdays, Christmas)',
    type: t.VariableType.single,
    description: 'Think about what you spend on Birthdays, Christmas, Mothers / Fathers days, wedding anniversaries',
    variable: 'Gifts_Amt',
    frequency: 'Gifts_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Online Shopping',
    type: t.VariableType.single,
    description: 'Consider Amazon, Adverts, Done Deal etc',
    variable: 'Online_Amt',
    frequency: 'Online_Freq',
    placeholder: '0.00'
  },
]

const name = 'Personal'
const title = 'Your Personal Expenses'
// tslint:disable-next-line
const description = "We all need to keep ourselves looking and feeling well, and have certain expenses that are attributed to ourselves as opposed to the wider household. From phones to haircuts and presents for the ones we love, these bits tend to add up…"
const outro = ''
const link = Routes.step4

const stepDefinition: t.StepDefinition = {
  index: 4,
  name,
  title,
  description,
  variables,
  outro,
  link,
}

export default stepDefinition
